import { createContext } from 'react';

const BookLocationModifiersContext = createContext({
  goToLocation: async (bookLocation) => {
    alert(`goToLocation: ${bookLocation?.href}`);
  },
});

export default BookLocationModifiersContext;
